module.exports = __webpack_public_path__ + "static/media/nptel_logo.3f216d1b.jpeg";